export default __webpack_public_path__ + "7dda8ac3f1ac6df20ddfc84aca72ae4e.webp";